import { inject, Injectable } from '@angular/core';
import { Route } from '@angular/router';
import { FormType, ROUTE_IDS, StepDefinition } from '@lx/quote-tool/shared/types';
import { StepService } from '@lx/quote-tool/shared/services/step-service';
import { QuoteFormDataResolver } from './quote-form-data.resolver';
import { QuoteFormComponent } from './quote-form.component';
import { StepDefinitionHelper } from '../../../shared/services/step-definition.helper';
import { Subject } from 'rxjs';

type FormTypeQuoteStepDefinition = {
  [key in Exclude<FormType, FormType.WIZARD>]: StepDefinition;
};

@Injectable({
  providedIn: 'root',
})
export class QuoteFormResolver {
  private readonly stepDefinitionHelper = inject(StepDefinitionHelper);

  private readonly requestValidation$ = new Subject<void>();
  private readonly submittableForm$ = new Subject<boolean>();

  constructor(private stepService: StepService) {}

  private quoteStepDefinitions: FormTypeQuoteStepDefinition = {
    [FormType.FREE_QUOTE]: {
      nextButton: $localize`Send to my email`,
      stepId: ROUTE_IDS.QUOTE_FORM,
      displayQuote: true,
      requestValidation$: this.requestValidation$,
      submittableForm$: this.submittableForm$,
      nextStep: () =>
        this.stepDefinitionHelper.getRouteIdToNavigateWithValidationForm(
          { requestValidation$: this.requestValidation$, submittableForm$: this.submittableForm$ },
          ROUTE_IDS.SEND_QUOTE_TO_EMAIL,
        ),
    },
    [FormType.ENROLLMENT]: {
      nextButton: $localize`Next`,
      stepId: ROUTE_IDS.QUOTE_FORM,
      displayQuote: true,
      nextStep: () => ROUTE_IDS.BOOKING_FORM,
    },
    [FormType.PRICE_REQUEST]: {
      nextButton: $localize`Send enquiry`,
      stepId: ROUTE_IDS.QUOTE_FORM,
      displayQuote: false,
      hideCtas: true,
      nextStep: () => ROUTE_IDS.SEND_QUOTE_TO_EMAIL,
    },
    [FormType.QUICK_QUOTE_TOOL]: {
      nextButton: $localize`Save for ARGO`,
      stepId: ROUTE_IDS.QUOTE_FORM,
      displayQuote: true,
      hideCtas: true,
      submitStep: true,
    },
  };

  resolve(): StepDefinition {
    return this.quoteStepDefinitions[this.stepService.getFormType()];
  }
}

export const stepRoute: Route = {
  path: ROUTE_IDS.QUOTE_FORM,
  resolve: {
    stepDefinition: () => inject(QuoteFormResolver).resolve(),
    data: () => inject(QuoteFormDataResolver).resolve(),
  },
  component: QuoteFormComponent,
};

export const rootRoute: Route = {
  ...stepRoute,
  path: ROUTE_IDS.FORM_ROOT,
};
